import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getSession, hasSessionRole } from '../../api/session';
import { BrandMark } from '../../components/shared/BrandMark';
import { loadAuthSession } from '../../data/authSession';
import '../../styles/partner.css';
import '../../styles/admin.css';

type AdminAccess = 'checking' | 'granted' | 'denied';

const NAV_ITEMS: Array<{ label: string; to: string; end?: boolean }> = [
  { label: '업체 승인 심사', to: '/admin', end: true },
  { label: '업체 등록 요청', to: '/admin/registration-requests' },
];

export function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = Boolean(loadAuthSession());

  const [access, setAccess] = useState<AdminAccess>('checking');

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(`/login?returnTo=${encodeURIComponent(location.pathname)}`, { replace: true });
    }
  }, [isAuthenticated, location.pathname, navigate]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    let cancelled = false;
    getSession()
      .then((session) => {
        if (cancelled) return;
        setAccess(hasSessionRole(session, 'ADMIN') ? 'granted' : 'denied');
      })
      .catch(() => {
        if (cancelled) return;
        setAccess('denied');
      });
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="partner-page">
      <header className="partner-header">
        <div className="partner-header__inner">
          <Link className="partner-header__brand" to="/admin">
            <BrandMark />
            <span className="partner-header__brand-badge admin-brand-badge">관리자</span>
          </Link>
          <nav aria-label="관리자 메뉴" className="partner-nav">
            {NAV_ITEMS.map((item) => (
              <NavLink
                className={({ isActive }) =>
                  `partner-nav__link${isActive ? ' partner-nav__link--active' : ''}`
                }
                end={item.end}
                key={item.to}
                to={item.to}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="partner-header__spacer" />
          <Link className="partner-header__home-link" to="/">
            밴더 홈으로
          </Link>
        </div>
      </header>
      <main className="partner-main">
        {access === 'checking' ? (
          <p className="partner-empty">권한을 확인하는 중…</p>
        ) : access === 'denied' ? (
          <div className="partner-card">
            <h2 className="partner-card__title">관리자 권한이 필요합니다</h2>
            <p className="partner-subtitle">
              관리자(ADMIN) 계정만 관리자 콘솔을 사용할 수 있습니다.
            </p>
            <Link className="partner-btn" to="/">
              홈으로 돌아가기
            </Link>
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
